import React, { ReactNode } from 'react';
import { ScrollView, VStack, Skeleton } from 'native-base';

import { theme } from '@breakroom-nx/assets';
import { Status } from '@breakroom-nx/helpers';
import { openModal, useAppDispatch } from '@breakroom-nx/redux';
import ErrorAndRefetch from '../misc/error-and-refetch/error-and-refetch';
import { SerializedError } from '@reduxjs/toolkit';
import { ResponsiveValue } from 'native-base/lib/typescript/components/types';

export interface TableViewProps {
  children: ReactNode;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | SerializedError | undefined;
  noData: boolean;
  noDataString: string;
  height?: ResponsiveValue<'full' | '1/2' | '1/3' | '1/4'>;
  px?: number;
  pb?: number;
  flex?: number;
  onRefetch: () => void;
}

export function TableView({
  children,
  isLoading,
  isSuccess,
  isError,
  error,
  noData,
  noDataString,
  height = 'full',
  px = 8,
  pb = 8,
  onRefetch,
}: TableViewProps) {
  const dispatch = useAppDispatch();

  return (
    <VStack height={height} flex={1}>
      {noData ? (
        <ErrorAndRefetch
          onRefetch={onRefetch}
          error={
            isError
              ? (error as SerializedError)?.message ?? 'Unknown Error Occured'
              : noDataString
          }
        />
      ) : (
        <ScrollView
          flex={1}
          showsVerticalScrollIndicator={true}
          _contentContainerStyle={{
            px: px,
            pb: pb,
          }}
        >
          {isLoading ? (
            <Skeleton
              width={'full'}
              height={'70px'}
              rounded="md"
              startColor={theme.colors.surface[200]}
              endColor={theme.colors.surface[400]}
            />
          ) : (
            children
          )}
        </ScrollView>
      )}
    </VStack>
  );
}

export default React.memo(TableView);
